import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { AppLayout } from './components/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { WorkbenchPage } from './pages/WorkbenchPage';
import { AiCenterPage } from './pages/AiCenterPage';
import { AiJobsPage } from './pages/AiJobsPage';
import { SettingsPage } from './pages/SettingsPage';
import { CalculatorsPage } from './pages/CalculatorsPage';
import { MenuManagementPage } from './pages/MenuManagementPage';
import { ExternalPage } from './pages/ExternalPage';
import { UsersPage } from './pages/UsersPage';
import { AuditPage } from './pages/AuditPage';

function ProtectedRoute() {
  return useAuth((state) => state.token) ? <Outlet /> : <Navigate to="/login" replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:id" element={<ProjectDetailPage />} />
          <Route path="/workbench" element={<WorkbenchPage />} />
          <Route path="/ai" element={<AiCenterPage />} />
          <Route path="/ai-jobs" element={<AiJobsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/calculators" element={<CalculatorsPage />} />
          <Route path="/menu-management" element={<MenuManagementPage />} />
          <Route path="/external/:menuId" element={<ExternalPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/audit" element={<AuditPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
